import { render } from "./mainPage.vue?vue&type=template&id=5062c272&scoped=true"
import script from "./mainPage.vue?vue&type=script&lang=js"
export * from "./mainPage.vue?vue&type=script&lang=js"

import "./mainPage.vue?vue&type=style&index=0&id=5062c272&lang=css"
import "./mainPage.vue?vue&type=style&index=1&id=5062c272&lang=less"
import "./mainPage.vue?vue&type=style&index=2&id=5062c272&lang=less&scoped=true"
import "./mainPage.vue?vue&type=style&index=3&id=5062c272&lang=less"
import "./mainPage.vue?vue&type=style&index=4&id=5062c272&scoped=true&lang=css"
import "./mainPage.vue?vue&type=style&index=5&id=5062c272&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5062c272"]])

export default __exports__